
import { createStore } from 'vuex';
import createWebsocketPlugin from '../plugins/networking';
import router from '../router';
import VuexPersistence from 'vuex-persist'
import {set} from 'vue-gtag'

const vuexLocal = new VuexPersistence({
  reducer: (state) => ({
    authenticated: state.authenticated,
    teacherId: state.teacherId,
    userType: state.userType,
    currentSession: {
      ...state.currentSession
    },
    currentClass: {
      ...state.currentClass
    },
  })
})

const store = createStore({
  plugins: [vuexLocal.plugin, createWebsocketPlugin()],
  state: {
    dataUpdated: false,
    newClassAdded: false,
    classRemoved: false,
    loginSuccess: null,
    userType: null, // Controls differentiated experience for Teachers vs Devs
    client: null,
    opCodes: {
      TeacherClientLogin: 0,
      TeacherLoginFirstTime: 1,
      TeacherLoginExisting: 2,
      SetTeacherName: 3,
      GetTeachersClasses: 4,
      SetClassInfo: 5,
      SetStudentList: 6,
      LoginProblem: 7,
      AddTeacherClass: 8,
      GetStudentList: 9,
      SendStudentList: 10,
      UpdateTeacherClass: 11,
      RemoveTeacherClass: 12,
      DeleteClass: 13,
      CreateNewSession: 14,
      SendStoryboxList: 15,
      SendLevelList: 16,
      GetStoryboxSelection: 17,
      StartSession: 18,
      SetSessionSettings: 19,
      NewSessionCreated: 20,
      AssignInitialArtifacts: 21,
      BootStudent: 22,
      UpdateClassStudentList: 23,
      GetLevelAndStoryboxSelection: 24,
      VerizonTeacherClientLogin: 25,
      UpdateArtifactsList: 50,
      UpdateGroupList: 51,
      UpdateGroupScore: 99,
      PingPong: 200,
      UpdateStudentList: 202,
      UpdateSessionStarted: 209,
      TryRejoin: 500,
      TryRejoinSuccess: 501,
      TryRejoinFailed: 502,
      LogoutTeacher: 503,
      PastSessions: 504,
      EndSession: 505,
      StartSessionTimer: 100,
      UpdateSessionTimer: 101,
      PastSessionsCount: 510,
      PastSessionsBrief: 511,
      PastSessionData: 512,
      ResetStudent: 520,
      AdvanceGroupStage: 521,
    },
    teacherId: null,
    teacherInfo: {
      name: null,
      isFirstTime: true
    },
    pastSessionsCount: 0,
    pastSessionsBrief: [],
    pastSessionData: null,
    pastSessions: [],
    currentSession: {
      sessionId: null,
      storyboxList: [],
      levelList: [],
      selectedStorybox: "",
      selectedLevel: "",
      sessionTimer: null,
      updateSessionTimer: null,
      startDateTime: null,
      interval: null,
      sessionStarted: false,
      sessionSettings: {
        gameMode: null,
        isTimeLimitEnabled: false,
        timeLimit: 30,
        backgroundMusic: false,
        narration: false,
        soundEffects: false
      },
      artifactsList: [],
      groupList: [],
      studentList: []
    },
    lastMessage: null,
    connected: false,
    authenticated: false,
    currentClass: {
      classId: null,
      classInfo: {
        nickname: null,
        checkedDay: [],
        grade: null,
        subject: null,
      },
      studentList: [],
    },
    studentList: [],
    allClasses: [],
  },
  mutations: {
    SET_CURRENT_CLASS(state, payload) {
      state.currentClass = payload;
    },
    SET_AUTHENTICATION(state, status) {
      state.authenticated = status;
      if (!status) state.teacherId = null;
    },
    ADD_CLIENT_CONNECTION(state, clientConnection) {
      state.client = clientConnection;
    },
    SET_CONNECTION(state, connectionState) {
      state.connected = connectionState;
    },
    CLOSE_CONNECTION(state) {
      // state.connected = connectionState;
      state.client.close();
    },
    INCREMENT_TIMELIMIT(state, amount) {
      state.currentSession.sessionSettings.timeLimit += amount;
    },
    DECREMENT_TIMELIMIT(state, amount) {
      state.currentSession.sessionSettings.timeLimit -= amount;
    },
    SET_NEWCLASS_ADDED(state, payload) {
      state.newClassAdded = payload;
    },
    SET_CLASS_REMOVED(state, payload) {
      state.classRemoved = payload;
    },
    SET_USER_TYPE(state, payload) {
      state.userType = payload;
    },
    GET_MESSAGE(state, message) {
      state.lastMessage = JSON.parse(message);
      state.dataUpdated = true;

      switch (state.lastMessage.opCode) {
        case state.opCodes.PingPong:
          setTimeout(function () {
            state.client.send(JSON.stringify(
              {
                action: "message",
                data: null,
                opCode: state.opCodes.PingPong
              }
            ))
          }, 540000);
          break;
        case state.opCodes.PastSessionsCount:
          state.pastSessionsCount = state.lastMessage.data;
          break;
        case state.opCodes.PastSessionsBrief:
          state.pastSessionsBrief = state.lastMessage.data;
          break;
        case state.opCodes.PastSessionData:
          state.pastSessionData = state.lastMessage.data;
          break;
        case state.opCodes.UpdateSessionStarted:
          state.currentSession.sessionStarted = state.lastMessage.data;
          break;
        case state.opCodes.TryRejoinSuccess:
          state.teacherInfo.name = state.lastMessage.data.teacherName;
          state.teacherInfo.isFirstTime = state.lastMessage.data.isFirstTime;
          state.currentSession.sessionId = state.lastMessage.data.currentSession.sessionId;
          state.currentSession.storyboxList = state.lastMessage.data.currentSession.storyboxList;
          state.currentSession.levelList = state.lastMessage.data.currentSession.levelList.sort((a,b) => (a.levelId > b.levelId) ? 1: -1);
          state.currentSession.selectedStorybox = state.lastMessage.data.currentSession.selectedStorybox;
          state.currentSession.selectedLevel = state.lastMessage.data.currentSession.selectedLevel;
          state.currentSession.sessionSettings.gameMode = state.lastMessage.data.currentSession.sessionSettings.gameMode;
          state.currentSession.sessionSettings.isTimeLimitEnabled = state.lastMessage.data.currentSession.sessionSettings.isTimeLimitEnabled;
          state.currentSession.sessionSettings.timeLimit = state.lastMessage.data.currentSession.sessionSettings.timeLimit;
          state.currentSession.sessionSettings.backgroundMusic = state.lastMessage.data.currentSession.sessionSettings.backgroundMusic;
          state.currentSession.sessionSettings.narration = state.lastMessage.data.currentSession.sessionSettings.narration;
          state.currentSession.sessionSettings.soundEffects = state.lastMessage.data.currentSession.sessionSettings.soundEffects;
          state.currentSession.groupList = state.lastMessage.data.currentSession.groupList;
          state.currentSession.studentList = state.lastMessage.data.currentSession.studentList;
          state.studentList = state.lastMessage.data.studentList;
          state.currentClass = state.lastMessage.data.currentClass;
          state.allClasses = state.lastMessage.data.allClasses;
          state.pastSessionsCount = state.lastMessage.data.pastSessionsCount;
          state.pastSessionsBrief = state.lastMessage.data.pastSessionsBrief;
          state.pastSessionData = state.lastMessage.data.pastSessionData;
          break;
        case state.opCodes.TryRejoinFailed:
          break;
        case state.opCodes.PastSessions:
          if (state.pastSessions.filter(item => item.sessionId == state.lastMessage.data.sessionId).length == 0) {
            state.pastSessions.push(state.lastMessage.data);
          }
          else {
            for (let i = 0; i < state.pastSessions.length; i++) {
              if (state.pastSessions[i].sessionId == state.lastMessage.data.sessionId) {
                state.pastSessions[i] = state.lastMessage.data;
              }
            }
          }
          break;
        case state.opCodes.TeacherLoginFirstTime:
          state.teacherId = state.lastMessage.data;
          state.authenticated = true;
          set({'user_id': state.teacherId});
          set({'user_properties': {'user_id_dimension': state.teacherId} });
          // event('user_id_event', {'user_id_dimension': state.teacherId});
          router.push({ name: 'account' });
          break;
        case state.opCodes.TeacherLoginExisting:
          state.teacherId = state.lastMessage.data.teacherId;
          state.teacherInfo.name = state.lastMessage.data.teacherName;
          state.teacherInfo.isFirstTime = false;
          state.authenticated = true;
          set({'user_id': state.teacherId});
          set({'user_properties': {'user_id_dimension': state.teacherId} });
          // event('user_id_event', {'user_id_dimension': state.teacherId});
          if (state.allClasses.length > 0) router.push({ name: 'class-list' });
          else router.push({ name: 'add-class' });
          break;
        case state.opCodes.LoginProblem:
          state.authenticated = false;
          state.loginSuccess = false;
          console.log("Error: " + state.lastMessage.data);
          break;
        case state.opCodes.GetTeachersClasses:
          state.allClasses = state.lastMessage.data.Items;
          break;
        case state.opCodes.AddTeacherClass:
          state.allClasses.push(state.lastMessage.data);
          if (router.currentRoute.value.name == 'add-class') { router.replace({ name: 'class-list' }); }
          break;
        case state.opCodes.SendStudentList:
          state.studentList = state.lastMessage.data;
          break;
        case state.opCodes.UpdateTeacherClass:
          state.allClasses.filter(
            (item) => item.classId == state.lastMessage.data.classId
          )[0].studentList = state.lastMessage.data.studentList;
          break;
        case state.opCodes.RemoveTeacherClass:
          var classId = state.lastMessage.data.classId;
          for (let index = 0; index < state.allClasses.length; index++) {
            let item = state.allClasses[index];
            if (item.classId == classId) {
              state.allClasses.splice(index, 1);
            }
          }
          break;
        case state.opCodes.NewSessionCreated:
          state.currentSession.sessionId = state.lastMessage.data.sessionId;
          state.currentSession.studentList = state.lastMessage.data.studentList;
          break;
        case state.opCodes.StartSessionTimer:
          state.currentSession.sessionTimer = state.lastMessage.data.totalTime;
          state.currentSession.startDateTime = state.lastMessage.data.startDateTime;
          state.currentSession.interval = setInterval(() => {
            console.log('running')
            state.currentSession.updateSessionTimer = (state.currentSession.sessionTimer) - ((Date.now() - state.currentSession.startDateTime) / 1000);
            if (state.currentSession.updateSessionTimer <= 0) {
              state.client.send(JSON.stringify(
                {
                  action: "message",
                  data: {
                    sessionId: state.currentSession.sessionId,
                    teacherId: state.teacherId,
                  },
                  opCode: state.opCodes.EndSession
                }
              ));
              clearInterval(state.currentSession.interval);
            }
          }, 10);
          break;
        case state.opCodes.EndSession:
          if (state.currentSession.interval) clearInterval(state.currentSession.interval);
          state.currentSession.sessionStarted = false;
          break;
        case state.opCodes.SendStoryboxList:
          state.currentSession.storyboxList = state.lastMessage.data;
          break;
        case state.opCodes.SendLevelList:
          state.currentSession.levelList = state.lastMessage.data.sort((a,b) => (a.levelId > b.levelId) ? 1: -1);
          break;
        case state.opCodes.UpdateArtifactsList:
          state.currentSession.artifactsList = state.lastMessage.data;
          break;
        case state.opCodes.UpdateGroupList:
          //var groupList = state.lastMessage.data.groupList;
          let groupList;

          if(state.lastMessage.data.groupList){
            groupList = state.lastMessage.data.groupList
          } 
          else {
            groupList = state.lastMessage.data
          }
          
          console.log("GROUPLIST: ", groupList)
          state.currentSession.groupList = groupList;
          break;
        case state.opCodes.UpdateStudentList:
          var studentList = state.lastMessage.data.studentList;
          state.currentSession.studentList = studentList;
          break;
        case state.opCodes.UpdateGroupScore:
          var groupIdx = state.lastMessage.data.groupIdx;
          var score = state.lastMessage.data.score;
          state.currentSession.groupList[groupIdx].score = score;
          break;
        default:
          break;
      }
    },
    SEND_MESSAGE(state, payload) {
      console.log("SENDING MESSGAE",payload )
      state.sendPayload = payload;
    },
    SET_TEACHER_NAME(state, payload) {
      state.teacherInfo.name = payload;
    },
    UPDATE(state, payload) {
      state.dataUpdated = payload;
    },
    SET_SESSION_UPDATE_TIMER(state, payload) {
      state.currentSession.updateSessionTimer = payload;
    },
    SET_SESSION_ID(state, payload) {
      state.currentSession.sessionId = payload;
    },
    CLEAR_CURRENT_SESSION(state) {
      state.currentSession = {
        sessionId: null,
        storyboxList: [],
        levelList: [],
        selectedStorybox: "",
        selectedLevel: "",
        sessionTimer: null,
        updateSessionTimer: null,
        startDateTime: null,
        interval: null,
        sessionStarted: false,
        sessionSettings: {
          gameMode: null,
          isTimeLimitEnabled: false,
          timeLimit: 30,
          backgroundMusic: false,
          narration: false,
          soundEffects: false
        },
        artifactsList: [],
        groupList: [],
        studentList: []
      }
    },
    RERUN_TIMER(state) {
      state.currentSession.interval = setInterval(() => {
        console.log('running')
        state.currentSession.updateSessionTimer = (state.currentSession.sessionTimer) - ((Date.now() - state.currentSession.startDateTime) / 1000);
        if (state.currentSession.updateSessionTimer <= 0) {
          state.client.send(JSON.stringify(
            {
              action: "message",
              data: {
                sessionId: state.currentSession.sessionId,
                teacherId: state.teacherId,
              },
              opCode: state.opCodes.EndSession
            }
          ));
          clearInterval(state.currentSession.interval);
        }
      }, 10);
    }
  },
  actions: {
    addClientConnection({ commit }, clientConnection) {
      commit('ADD_CLIENT_CONNECTION', clientConnection);
    },
    connectionOpened({ commit }) {
      commit('SET_CONNECTION', true);
    },
    connectionClosed({ commit }) {
      commit('SET_CONNECTION', false);
    },
    closeConnection({ commit }) {
      commit('CLOSE_CONNECTION');
      commit('SET_CONNECTION', false);
      commit('SET_AUTHENTICATION', false);
    },
    connectionError({ commit }) {
      commit('SET_CONNECTION', false);
    },
    connectionMessage({ commit }, message) {
      commit('GET_MESSAGE', message);
    },
    setTeacherName({ commit }, teacherInfo) {
      commit('SET_TEACHER_NAME', teacherInfo)
    },
    setNewClassAdded({ commit }, newClass) {
      commit('SET_NEWCLASS_ADDED', newClass)
    },
    setClassRemoved({ commit }, newClass) {
      commit('SET_CLASS_REMOVED', newClass)
    },
    setSessionUpdateTimer({ commit }, totalTime) {
      commit('SET_SESSION_UPDATE_TIMER', totalTime);
    },
    setUserType({ commit }, type) {
      commit('SET_USER_TYPE', type);
    },
  },
  modules: {},
  getters: {
    getCurrentClass(state) {
      return state.currentClass
    }
  }
})


export default store;